module.exports = __webpack_public_path__ + "img/start-3.5f853ae6.png";